var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { IsDateString, IsObject, IsOptional, IsString, IsUUID, ValidateNested, } from 'class-validator';
import { HubSpotQuestionResponseDto } from './hubspot-question.response.dto.js';
/**
 * Response DTO for HubSpotQuestionAnswer.
 * Used for API responses (query operations).
 */
export class HubSpotQuestionAnswerResponseDto {
    id;
    createdAt;
    updatedAt;
    answer;
    questionId;
    userId;
    question;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], HubSpotQuestionAnswerResponseDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", Date)
], HubSpotQuestionAnswerResponseDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", Date)
], HubSpotQuestionAnswerResponseDto.prototype, "updatedAt", void 0);
__decorate([
    IsString(),
    Expose(),
    IsOptional(),
    __metadata("design:type", Object)
], HubSpotQuestionAnswerResponseDto.prototype, "answer", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], HubSpotQuestionAnswerResponseDto.prototype, "questionId", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], HubSpotQuestionAnswerResponseDto.prototype, "userId", void 0);
__decorate([
    IsObject(),
    ValidateNested(),
    Type(() => HubSpotQuestionResponseDto),
    Expose(),
    __metadata("design:type", HubSpotQuestionResponseDto)
], HubSpotQuestionAnswerResponseDto.prototype, "question", void 0);
//# sourceMappingURL=hubspot-question-answer.response.dto.js.map